import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import CategoryManagement from '../../components/templates/admin/CategoryManagement';

const CategoryManagementPage = () => {
  return (
    <AdminLayout>
      <CategoryManagement />
    </AdminLayout>
  );
};

export default CategoryManagementPage;
